import axios from 'axios'

axios.defaults.headers.common['X-TENANT-ID'] = process.env.VUE_APP_TENANT_ID;
